import images from 'assets/images/images'
import React from 'react'

const LoaderTwo = ({ isDataLoading }) => {
  return (
    <div className={`loader ${isDataLoading ? 'active':''}`}>
        <img src={images.loading} alt="" />
    </div>
    
  )
}

export default LoaderTwo